import { render, staticRenderFns } from "./poi-gallery-items.vue?vue&type=template&id=00abfa6c&"
import script from "./poi-gallery-items.vue?vue&type=script&lang=ts&"
export * from "./poi-gallery-items.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports